<div class="matform">
  <edit-input
    class="editIcon"
    (emitInputUpdate)="updateResource($event)"
    [iconClass]="resourceData?.IconClass"
    [inputName]="formControlName"
    [viewName]="resourceData?.Title"
  ></edit-input>

  <mat-form-field [ngClass]="class">
    <mat-select
      (blur)="touch($event)"
      [(ngModel)]="value"
      (selectionChange)="changeSelection($event)"
      [placeholder]="this.placeHolder"
      [disabled]="disabled || resourceData?.Disabled"
      [errorStateMatcher]="customMatcher"
      [attr.data-name]="this.formControlName"
      [attr.data-Sitefinity]="resourceData?.Title"
      [attr.data-Id]="customElementId"
    >
      <mat-select-trigger>
        <div
          class="mat-select-content"
          [class.iconRightPosition]="iconPosition === 'right'"
        >
          <mat-icon
            color="primary"
            *ngIf="customIcon && value?.IconFont"
            [svgIcon]="value?.IconFont"
          >
          </mat-icon>
          <mat-icon color="primary" *ngIf="!customIcon && value?.IconFont">
            {{ value?.IconFont }}
          </mat-icon>
          {{ value?.Value }}
        </div>
      </mat-select-trigger>
      <mat-option
        *ngFor="let item of listItems"
        [value]="item"
        [class.iconRightPosition]="iconPosition === 'right'"
      >
        <mat-icon color="primary" *ngIf="!customIcon && item.IconFont">
          {{ item.IconFont }}
        </mat-icon>
        <mat-icon
          color="primary"
          *ngIf="customIcon && item.IconFont"
          [svgIcon]="value?.IconFont"
        >
        </mat-icon>
        {{ item.Value }}
      </mat-option>
    </mat-select>
    <mat-error>
      <validation-messages
        *ngIf="(invalid | async) && !disabled"
        [messages]="failures | async"
      >
      </validation-messages>
    </mat-error>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  </mat-form-field>
</div>
